import React from 'react';
import styles from './Header.module.css';
import { Link } from 'react-router-dom';
import { FiArrowRightCircle } from "react-icons/fi";
import validator from 'validator';
import * as utils from '../../utils/utils';

export default class Header extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
        };
    };

    componentDidMount() {
        if ( utils.isLoggedIn() ) {
            let email = utils.getUserEmail();
            console.log('logged in', email)

            if ( email !== undefined ) {
                email = email.substring(0, 1);

                this.setState({
                    email,
                });
            }
        }
    };

    logout = () => {
        utils.sendRequest('/web/user/logout',{})
        .then(responseData => {
            utils.removeAuthDetails();

            window.location = '/';
        })
        .catch(error => {
            console.log('logout error', error);
            alert('There was an error. Please try again in a bit.');
        });
    };
    
    render() {
        return (
            <div className={styles.headerView}>
                <div className={styles.headerIconContainer}>
                    <div className={styles.headerIconImageContainer}>
                        <img src={require('../../assets/icon.png')} className={styles.headerIconImage} />
                    </div>
                    <div className={styles.headerIconText}>SnapQuizAI</div>
                </div>
                {
                    this.state.email !== '' &&
                    <div
                        className={styles.headerLogoutText}
                        onClick={this.logout}
                    >
                        Logout
                    </div>
                }
                {/* <div className={styles.headerGetAppContainer}>
                    <a href={this.appLink}>
                        <div className={styles.headerGetApp}>
                            Get App
                        </div>
                    </a>
                </div> */}
            </div>
        );
    };
};
